import { render, staticRenderFns } from "./AddAndEditStore.vue?vue&type=template&id=42a83606&scoped=true&"
import script from "./AddAndEditStore.vue?vue&type=script&lang=ts&"
export * from "./AddAndEditStore.vue?vue&type=script&lang=ts&"
import style0 from "./AddAndEditStore.vue?vue&type=style&index=0&id=42a83606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a83606",
  null
  
)

export default component.exports